export const CURRENCY_LIST = [
  { code: "EUR", symbol: "€",    label: "Euro" },
  { code: "GBP", symbol: "£",    label: "British Pound" },
  { code: "USD", symbol: "$",    label: "US Dollar" },
  { code: "AED", symbol: "د.إ", label: "UAE Dirham" },
  { code: "PKR", symbol: "₨",   label: "Pakistani Rupee" },
  { code: "CAD", symbol: "$",    label: "Canadian Dollar" },
  { code: "AUD", symbol: "$",    label: "Australian Dollar" },
  { code: "NZD", symbol: "$",    label: "New Zealand Dollar" },
  { code: "SGD", symbol: "$",    label: "Singapore Dollar" },
  { code: "CHF", symbol: "Fr",   label: "Swiss Franc" },
  { code: "SAR", symbol: "ر.س", label: "Saudi Riyal" },
  { code: "EGP", symbol: "£",    label: "Egyptian Pound" },
  { code: "TRY", symbol: "₺",   label: "Turkish Lira" },
  { code: "INR", symbol: "₹",   label: "Indian Rupee" },
  { code: "BDT", symbol: "৳",   label: "Bangladeshi Taka" },
  { code: "THB", symbol: "฿",   label: "Thai Baht" },
  { code: "MYR", symbol: "RM",   label: "Malaysian Ringgit" },
  { code: "IDR", symbol: "Rp",   label: "Indonesian Rupiah" },
  { code: "CNY", symbol: "¥",    label: "Chinese Yuan" },
  { code: "JPY", symbol: "¥",    label: "Japanese Yen" },
  { code: "KRW", symbol: "₩",   label: "South Korean Won" },
  { code: "RUB", symbol: "₽",   label: "Russian Ruble" },
];

export const CURRENCY_SYMBOLS = Object.fromEntries(CURRENCY_LIST.map(c => [c.code, c.symbol]));

export const sym = (code) => CURRENCY_SYMBOLS[code] || (code ? code + " " : "€");
